<script>
import CardViewingCommentForMethologist from "../Cards/CardViewingCommentForMethologist.vue";
import CardViewingComment from "../Cards/CardViewingComment.vue";
import _ from "lodash";
import {mapActions, mapState} from "vuex";

export default {
  name: "TableListComments",
  components: {CardViewingComment, CardViewingCommentForMethologist},
  props: {
    window_index_conf: {
      type: Number
    },
    definition_role: {
      type: Boolean
    },
    role_key: {
      type: Number
    },
    selected_tech_map: {
      type: Object
    }
  },
  data: () => ({
    headers_table_tech_map: [
      {text: '№', value: 'index', sortable: false, align: "center", filterable: false},
      {text: 'Тип коментария', value: 'type_comment', sortable: false, align: "center", filterable: false},
      {text: 'Дата отправления', value: 'created_at', align: "center", sortable: false, filterable: false},
      {text: 'Подробнее', value: 'action', align: "center", sortable: false, filterable: false},
    ],
    page: 1,
    pageCount: 0,
    index_window_view_comment: 0,
    select_comment: {},
    mouse_over: false
  }),
  computed: {
    ...mapState({
      list_comments: state => state.studyEstEukTechMapCommission.list_comments,
    })
  },
  methods: {
    ...mapActions({
      deleteCommissionStatuses: 'studyEstEukTechMapCommission/deleteCommissionStatuses',
    }),
    numberComment(item_table) {
      return _.findIndex(this.list_comments, (comment) => {
        return comment.id === item_table.id
      }) + 1
    },
    setStatus(status) {
      if (status === 'Одобрение') {
        return {color: 'green', icon: 'fa fa-check-circle'}
      } else if (status === 'Отклонение') {
        return {color: 'red', icon: 'fa fa-times-circle'}
      }
    },
    setIndexWindowFormComment() {
      this.$emit('setIndexWindowFormComment', {
        window_index_conf: 1
      })
    },
    openSelectedTechMap(item) {
      this.index_window_view_comment = 1
      this.select_comment = item
    },
    setIndexWindowListComments() {
      this.index_window_view_comment = 0
    },
    destroyComments(){
      let data_commission = {
        role_key: this.role_key,
        technological_map_id: this.selected_tech_map.id,
      }
      this.deleteCommissionStatuses(data_commission).then(() => {this.setIndexWindowFormComment()})
    }
  }
}
</script>

<template>
  <v-card
      class="rounded-xl"
      height="100%"
      tile
  >
    <v-card-text style="height: 100%" class="overflow-hidden pa-0">
      <v-window style="height: 100%" v-model="index_window_view_comment">
        <v-window-item style="height: 100%">
          <v-card style="height: 100%">
            <v-card-text class="pa-0" style="height: calc(100% - 65px)">
              <v-data-table
                  :headers="headers_table_tech_map"
                  :items="list_comments"
                  no-data-text="Данные курса отсутствуют"
                  :items-per-page="10"
                  :page.sync="page"
                  item-key="id"
                  @page-count="pageCount = $event"
                  height="100%"
                  mobile-breakpoint="0"
                  hide-default-footer
                  outlined
              >
                <template v-slot:top>
                  <v-app-bar
                      elevation="0"
                  >
                    <v-btn
                        @click="destroyComments()"
                        @mouseover="mouse_over = true"
                        @mouseleave="mouse_over = false"
                        outlined
                        color="red"
                        elevation="0"
                        fab
                        small
                    >
                      <v-icon size="15px">
                        fa-trash
                      </v-icon>
                    </v-btn>
                    <v-scroll-x-transition>
                      <div v-if="mouse_over" class="ml-2 red--text text-h6">Удалить оценки ТК</div>
                    </v-scroll-x-transition>
                    <v-spacer></v-spacer>

                    <v-btn
                        @click="setIndexWindowFormComment()"
                        elevation="0"
                        rounded
                        outlined
                        color="teal"
                    >
                      <v-icon left size="15px">
                        fa-check-square
                      </v-icon>
                      Оценить повторно
                    </v-btn>
                  </v-app-bar>
                </template>
                <template v-slot:item.index="{ item }">
                  <v-chip
                      color="grey darken-1"
                      outlined
                      small
                      rounded
                      elevation="0"
                  >
                    <v-icon small left>
                      fa fa-comments
                    </v-icon>
                    <div class="text-subtitle-1">
                      {{ numberComment(item) }}
                    </div>
                  </v-chip>
                </template>
                <template v-slot:item.type_comment="{ item }">
                  <v-chip
                      small
                      rounded
                      elevation="0"
                      :color="setStatus(item.type_comment).color"
                      outlined
                  >
                    {{ item.type_comment }}
                    <v-icon small right>
                      {{ setStatus(item.type_comment).icon }}
                    </v-icon>
                  </v-chip>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                      @click="openSelectedTechMap(item)"
                      icon
                  >
                    <v-icon size="15px">
                      fa fa-chevron-right
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-pagination
                  v-if="list_comments.length > 10"
                  class="mx-auto"
                  v-model="page"
                  :length="pageCount"
                  total-visible="8"
                  color="teal"
                  circle
              ></v-pagination>
            </v-card-actions>
          </v-card>
        </v-window-item>
        <v-window-item style="height: 100%">
          <CardViewingCommentForMethologist
              v-if="role_key === 3"
              :select_comment="select_comment"
              :selected_tech_map="selected_tech_map"
              @setIndexWindowListComments="setIndexWindowListComments"
          />
          <CardViewingComment
              v-else
              :select_comment="select_comment"
              @setIndexWindowListComments="setIndexWindowListComments"
          />
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.v-data-table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}

.v-speed-dial {
  position: absolute;
}
</style>